// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__rj2Wt","card":"page_card__ui6mT","cardContainer":"page_cardContainer__XF4us","typeSelectorContainer":"page_typeSelectorContainer__OavZa"};